import { memo } from 'react';
import { StepViewComponentProps } from '../stepDescriptor/types';
import ExperimentalToolUseTaskComponent from './ExperimentalToolUseTaskComponent';

function ExperimentalToolUsePinnedViewComponent({
  readOnly,
  complete,
  responseIndex,
}: StepViewComponentProps) {
  return (
    <ExperimentalToolUseTaskComponent
      isPinnable
      isPinnedView
      readOnly={readOnly}
      complete={complete}
      responseIndex={responseIndex}
    />
  );
}

export default memo(ExperimentalToolUsePinnedViewComponent);
